import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '../../utilities/style-utilities';
import { fontUbuntuLight } from '../../utilities/utilities';

const FooterWrapper = styled.footer`
  background: ${props => props.background ? props.background : 'rgb(0, 135, 208)'};
 
  display: flex;
  flex: 1 0 auto;
  justify-content: center;

  ${ media.mobile`
    font-size: 0.9em;
  `}
`;

const FooterInner = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 964px;
  width: 100%;
  ${ media.desktop`
    padding: 0 1rem;
  `}
`;

const Line = styled.div`
  border-top: 2px solid ${props => props.lineDividerColor ? props.lineDividerColor : 'rgb(255, 255, 255)'};
  flex: 1 1 auto;
`;

const FlexRow = styled.div`
  display:flex;
  width: 100%;
  margin: 0.5rem 0 1rem 0;
`;

const FlexItem = styled.div`
  flex: 1 1 auto;
  align-self: flex-end;
`;

const FlexItemOrder = styled.div`
  flex: 1 1 auto;
  align-self: flex-end;
  display: flex;
`;

const LogoImage = styled.img`
  max-width: 100%;
  max-height:30px;
  height:auto;
  display: block;
  margin-right: 1rem;
  ${props => props.order && css`
    order: ${props.order};
  `}
  ${ media.mobile`
    max-height: 25px;
  `}
`;

const DisclaimerParagraph = styled.p`
  font-size:0.7275em;
  color: ${props => props.textColor ? props.textColor : 'rgb(255, 255, 255)'};
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  margin: 1rem 0;
  max-width: 100%;
`;

const Nav = styled.nav`
  
`;

const NavList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  text-align: right;

  ${ media.desktop`
    flex-direction: column;
    align-items: flex-end;
  `}
`;

const NavListItem = styled.li`
  margin-left: 1rem;
`;

const StyledLink = styled(Link)`
  font-size: 0.836875em;
  color: ${props => props.color ? props.color : 'rgb(255, 255, 255)'};
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};

  &:visited {
    color: ${props => props.visited ? props.visited : 'rgb(255, 255, 255)'};
  }
`;

const Copyright = styled.span`
  display: flex;
  justify-content: flex-end;
  font-size:0.6875em;
  color: ${props => props.textColor ? props.textColor : 'rgb(255, 255, 255)'};
  font-family: ${props => props.fontFamily ? props.fontFamily :  fontUbuntuLight};
  margin-top: 1rem;
`;

const Footer = (props) => {
  return (
    <FooterWrapper background={props.footer.backgroundColor} >
      <FooterInner >
        <Line lineDividerColor={props.footer.lineDividerColor}/>
        <DisclaimerParagraph fontFamily={props.footer.fontFamily} textColor={props.footer.textColor}>This card is issued by PrePay Technologies Limited pursuant to license by Mastercard International. PrePay Technologies Limited is authorised by the Financial Conduct Authority under the Electronic Money Regulations 2011 (FRN: 900010) for the issuing of electronic money and payment instruments. Mastercard is a registered trademark, and the circles design is a trademark of Mastercard International Incorporated.</DisclaimerParagraph>
        <FlexRow>
          <FlexItemOrder>
            {(props.footer.companyLogoSrc !== null || props.footer.companyLogoSrc !== undefined) && props.footer.companyLogoSrc !== '' ? 
              <LogoImage src={props.footer.companyLogoSrc} alt={props.footer.companyLogoAlt} order={props.footer.companyLogoOrder}/>
            :
              null
            }
            <LogoImage src={props.footer.mastercardLogo} alt={props.footer.mastercardLogoAlt} />
            <LogoImage src={props.footer.applePayLogo} alt={props.footer.applePayLogoAlt} />
            <LogoImage src={props.footer.googlePayLogo} alt={props.footer.googlePayLogoAlt} />
          </FlexItemOrder>
          <FlexItem>
            <Nav>
              <NavList>
                <NavListItem>
                  <StyledLink fontFamily={props.footer.fontFamily} color={props.footer.linkColor} visited={props.footer.linkVisitedColor} to="https://www.edenred.co.uk/legal/legal-entity/terms-of-use/" target="_blank">Website Information</StyledLink>
                </NavListItem>
                <NavListItem>
                  <StyledLink fontFamily={props.footer.fontFamily} color={props.footer.linkColor} visited={props.footer.linkVisitedColor} to="https://www.edenred.co.uk/legal/legal-entity/privacy-policy/" target="_blank">Privacy Policy</StyledLink>
                </NavListItem>
                <NavListItem>
                  <StyledLink fontFamily={props.footer.fontFamily} color={props.footer.linkColor} visited={props.footer.linkVisitedColor} to={`${props.url === '/' ? '' : props.url}/terms`} target="_blank">Prepaid Card T&amp;Cs</StyledLink>
                </NavListItem>
                <NavListItem>
                  <StyledLink fontFamily={props.footer.fontFamily} color={props.footer.linkColor} visited={props.footer.linkVisitedColor} to={`${props.url === '/' ? '' : props.url}/faq`} target="_blank">FAQs</StyledLink>
                  {/* <StyledLink color={props.footer.linkColor} visited={props.footer.linkVisitedColor} to="https://www.edenred.co.uk/reward-recipients/how-to-use-my-incentive-award-card1/edenred-incentive-award-card-faqs/#.Wjul01Vl-Uk" target="_blank">FAQs</StyledLink> */}
                </NavListItem>
                {props.clientTerms != null ? 
                  <NavListItem>
                    <StyledLink fontFamily={props.footer.fontFamily} color={props.footer.linkColor} visited={props.footer.linkVisitedColor} to={props.clientTerms.linkUrl} target="_blank">{props.clientTerms.linkText}</StyledLink>
                  </NavListItem>
                : null}
              </NavList>
            </Nav>
            <Copyright fontFamily={props.footer.fontFamily} textColor={props.footer.textColor}>Copyright &copy; Edenred {new Date().getFullYear()}</Copyright>
          </FlexItem>
        </FlexRow>
      </FooterInner>
    </FooterWrapper>
  )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js